import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
/**
 * Auth inline error banner (Figma: node 1480:20470)
 * Props:
 * - message: string | { title?: string; description?: string }
 * - title: optional string (overrides message.title)
 * - description: optional string (overrides message.description)
 */
export default function AuthErrorBanner({ message, title, description, flag }) {
    const derived = typeof message === "object" && message
        ? {
            title: message.title ?? "",
            description: message.description ?? "",
        }
        : { title: String(message || ""), description: "" };
    const finalTitle = (title ?? derived.title ?? "").trim();
    const finalDescription = (description ?? derived.description ?? "").trim();
    if (!finalTitle && !finalDescription)
        return null;
    return (_jsxs(Box, { sx: {
            width: "100%",
            backgroundColor: "#fee7ef", // danger-50
            borderRadius: "8px", // unit-xs
            padding: "12px", // unit-sm
            display: "flex",
            alignItems: "center",
            gap: "16px", // unit-md
        }, children: [_jsx(Box, { component: "img", alt: "", src: flag ? "/assets/toastIcons/right-tick.svg" : "/assets/toastIcons/cross-icon.svg", sx: { width: 24, height: 24, flex: "0 0 24px" } }), _jsxs(Box, { sx: { flex: 1, minWidth: 0 }, children: [finalTitle && (_jsx(Typography, { sx: {
                            fontFamily: "Inter, sans-serif",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "20px",
                            color: "#b42318", // Error/700
                            whiteSpace: "pre-wrap",
                        }, children: finalTitle })), finalDescription && (_jsx(Typography, { sx: {
                            fontFamily: "Inter, sans-serif",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "20px",
                            color: "#52525b", // default-600
                            whiteSpace: "pre-wrap",
                        }, children: finalDescription }))] })] }));
}
